/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Authentication,
  ErrorResponse,
  HealthCard,
  HealthCardNumber,
  MinistryOHIP,
  MultipleValuesPayload,
  OHIPNumber,
  Patient,
  PatientListItem,
  StringResource,
  ViewAsPatientPayload,
} from '../models';
import {
    AuthenticationFromJSON,
    AuthenticationToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    HealthCardFromJSON,
    HealthCardToJSON,
    HealthCardNumberFromJSON,
    HealthCardNumberToJSON,
    MinistryOHIPFromJSON,
    MinistryOHIPToJSON,
    MultipleValuesPayloadFromJSON,
    MultipleValuesPayloadToJSON,
    OHIPNumberFromJSON,
    OHIPNumberToJSON,
    PatientFromJSON,
    PatientToJSON,
    PatientListItemFromJSON,
    PatientListItemToJSON,
    StringResourceFromJSON,
    StringResourceToJSON,
    ViewAsPatientPayloadFromJSON,
    ViewAsPatientPayloadToJSON,
} from '../models';

export interface ChangePhoneNumberRequest {
    id: string;
    phone: string;
    stringResource: StringResource;
}

export interface CheckHealthCardNumberRequest {
    healthCardNumber: HealthCardNumber;
}

export interface CheckOhipNumberRequest {
    oHIPNumber: OHIPNumber;
}

export interface DeactivateAccountRequest {
    patientId: string;
}

export interface ExportPatientsRequest {
    authentication: Authentication;
}

export interface GetMultiplePatientsRequest {
    multipleValuesPayload: MultipleValuesPayload;
}

export interface GetPatientRequest {
    id: string;
}

export interface GetPatientsRequest {
    search?: string;
    limit?: number;
    clinicId?: string;
}

export interface GetPhysicianPatientsRequest {
    physicianId: string;
    search?: string;
}

export interface GetPhysicianPatientsBySkillRequest {
    physicianId: string;
    skill: string;
}

export interface MarkDeceasedRequest {
    patientId: string;
    date: number;
}

export interface RemoveHealthCardRequest {
    patientId: string;
}

export interface RemoveOhipNumberRequest {
    patientId: string;
}

export interface SendSMSRequest {
    id: string;
    stringResource: StringResource;
}

export interface SubmitToCancellationListRequest {
    id: string;
    patientListItem: PatientListItem;
}

export interface TransferAccountRequest {
    from: string;
    to: string;
}

export interface UnlinkAccountsRequest {
    parentId: string;
    linkedId: string;
}

export interface UpdateHealthCardRequest {
    patientId: string;
    healthCard: HealthCard;
}

export interface UpdateOhipNumberRequest {
    patientId: string;
    oHIPNumber: OHIPNumber;
}

export interface UpdatePatientRequest {
    id: string;
    patient: Patient;
}

export interface ViewAsPatientRequest {
    patientId: string;
}

/**
 * 
 */
export class PatientsApi extends runtime.BaseAPI {

    /**
     * Confirms the phone number and changes it for a patient (Roles: patient)
     */
    async changePhoneNumberRaw(requestParameters: ChangePhoneNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Patient>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling changePhoneNumber.');
        }

        if (requestParameters.phone === null || requestParameters.phone === undefined) {
            throw new runtime.RequiredError('phone','Required parameter requestParameters.phone was null or undefined when calling changePhoneNumber.');
        }

        if (requestParameters.stringResource === null || requestParameters.stringResource === undefined) {
            throw new runtime.RequiredError('StringResource','Required parameter requestParameters.stringResource was null or undefined when calling changePhoneNumber.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/patients/{id}/change-phone/{phone}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"phone"}}`, encodeURIComponent(String(requestParameters.phone))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StringResourceToJSON(requestParameters.stringResource),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    changePhoneNumberRequestOptionsRaw(requestParameters: ChangePhoneNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling changePhoneNumber.');
        }

        if (requestParameters.phone === null || requestParameters.phone === undefined) {
            throw new runtime.RequiredError('phone','Required parameter requestParameters.phone was null or undefined when calling changePhoneNumber.');
        }

        if (requestParameters.stringResource === null || requestParameters.stringResource === undefined) {
            throw new runtime.RequiredError('StringResource','Required parameter requestParameters.stringResource was null or undefined when calling changePhoneNumber.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/patients/{id}/change-phone/{phone}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"phone"}}`, encodeURIComponent(String(requestParameters.phone))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: StringResourceToJSON(requestParameters.stringResource),
        };
        return responseConfig
    }

    /**
     * Confirms the phone number and changes it for a patient (Roles: patient)
     */
    async changePhoneNumber(requestParameters: ChangePhoneNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Patient> {
        const response = await this.changePhoneNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Checks a HealthCard number (Roles: admin)
     */
    async checkHealthCardNumberRaw(requestParameters: CheckHealthCardNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthCard>> {
        if (requestParameters.healthCardNumber === null || requestParameters.healthCardNumber === undefined) {
            throw new runtime.RequiredError('HealthCardNumber','Required parameter requestParameters.healthCardNumber was null or undefined when calling checkHealthCardNumber.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-card`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HealthCardNumberToJSON(requestParameters.healthCardNumber),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthCardFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    checkHealthCardNumberRequestOptionsRaw(requestParameters: CheckHealthCardNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.healthCardNumber === null || requestParameters.healthCardNumber === undefined) {
            throw new runtime.RequiredError('HealthCardNumber','Required parameter requestParameters.healthCardNumber was null or undefined when calling checkHealthCardNumber.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-card`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: HealthCardNumberToJSON(requestParameters.healthCardNumber),
        };
        return responseConfig
    }

    /**
     * Checks a HealthCard number (Roles: admin)
     */
    async checkHealthCardNumber(requestParameters: CheckHealthCardNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthCard> {
        const response = await this.checkHealthCardNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Checks a OHIP number (Roles: admin)
     */
    async checkOhipNumberRaw(requestParameters: CheckOhipNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MinistryOHIP>> {
        if (requestParameters.oHIPNumber === null || requestParameters.oHIPNumber === undefined) {
            throw new runtime.RequiredError('OHIPNumber','Required parameter requestParameters.oHIPNumber was null or undefined when calling checkOhipNumber.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ohip`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OHIPNumberToJSON(requestParameters.oHIPNumber),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MinistryOHIPFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    checkOhipNumberRequestOptionsRaw(requestParameters: CheckOhipNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.oHIPNumber === null || requestParameters.oHIPNumber === undefined) {
            throw new runtime.RequiredError('OHIPNumber','Required parameter requestParameters.oHIPNumber was null or undefined when calling checkOhipNumber.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ohip`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: OHIPNumberToJSON(requestParameters.oHIPNumber),
        };
        return responseConfig
    }

    /**
     * Checks a OHIP number (Roles: admin)
     */
    async checkOhipNumber(requestParameters: CheckOhipNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MinistryOHIP> {
        const response = await this.checkOhipNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deactivates a patient account (Roles: patient, admin)
     */
    async deactivateAccountRaw(requestParameters: DeactivateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Patient>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deactivateAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/patient/{patientId}/deactivate`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    deactivateAccountRequestOptionsRaw(requestParameters: DeactivateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deactivateAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/patient/{patientId}/deactivate`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Deactivates a patient account (Roles: patient, admin)
     */
    async deactivateAccount(requestParameters: DeactivateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Patient> {
        const response = await this.deactivateAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Exports a CSV with patient information (Roles: admin)
     */
    async exportPatientsRaw(requestParameters: ExportPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.authentication === null || requestParameters.authentication === undefined) {
            throw new runtime.RequiredError('Authentication','Required parameter requestParameters.authentication was null or undefined when calling exportPatients.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/patients/export`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthenticationToJSON(requestParameters.authentication),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
        Request Config Getter
     */
    exportPatientsRequestOptionsRaw(requestParameters: ExportPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.authentication === null || requestParameters.authentication === undefined) {
            throw new runtime.RequiredError('Authentication','Required parameter requestParameters.authentication was null or undefined when calling exportPatients.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/patients/export`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: AuthenticationToJSON(requestParameters.authentication),
        };
        return responseConfig
    }

    /**
     * Exports a CSV with patient information (Roles: admin)
     */
    async exportPatients(requestParameters: ExportPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.exportPatientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the Patients with the specified comma-separated ids (Roles:  physician, admin)
     */
    async getMultiplePatientsRaw(requestParameters: GetMultiplePatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Patient>>> {
        if (requestParameters.multipleValuesPayload === null || requestParameters.multipleValuesPayload === undefined) {
            throw new runtime.RequiredError('MultipleValuesPayload','Required parameter requestParameters.multipleValuesPayload was null or undefined when calling getMultiplePatients.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/patients/multiple`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MultipleValuesPayloadToJSON(requestParameters.multipleValuesPayload),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatientFromJSON));
    }

    /**
        Request Config Getter
     */
    getMultiplePatientsRequestOptionsRaw(requestParameters: GetMultiplePatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.multipleValuesPayload === null || requestParameters.multipleValuesPayload === undefined) {
            throw new runtime.RequiredError('MultipleValuesPayload','Required parameter requestParameters.multipleValuesPayload was null or undefined when calling getMultiplePatients.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/patients/multiple`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: MultipleValuesPayloadToJSON(requestParameters.multipleValuesPayload),
        };
        return responseConfig
    }

    /**
     * Returns the Patients with the specified comma-separated ids (Roles:  physician, admin)
     */
    async getMultiplePatients(requestParameters: GetMultiplePatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Patient>> {
        const response = await this.getMultiplePatientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the Patient with the specified id (Roles: patient, physician, admin)
     */
    async getPatientRaw(requestParameters: GetPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Patient>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPatient.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/patients/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getPatientRequestOptionsRaw(requestParameters: GetPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPatient.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/patients/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Returns the Patient with the specified id (Roles: patient, physician, admin)
     */
    async getPatient(requestParameters: GetPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Patient> {
        const response = await this.getPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all the Patients that the user has access to (Roles: patient, physician, admin)
     */
    async getPatientsRaw(requestParameters: GetPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Patient>>> {
        const queryParameters: any = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.clinicId !== undefined) {
            queryParameters['clinicId'] = requestParameters.clinicId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/patients`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatientFromJSON));
    }

    /**
        Request Config Getter
     */
    getPatientsRequestOptionsRaw(requestParameters: GetPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.clinicId !== undefined) {
            queryParameters['clinicId'] = requestParameters.clinicId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/patients`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Returns all the Patients that the user has access to (Roles: patient, physician, admin)
     */
    async getPatients(requestParameters: GetPatientsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Patient>> {
        const response = await this.getPatientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the Physician\'s patients (Roles: physician, admin)
     */
    async getPhysicianPatientsRaw(requestParameters: GetPhysicianPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Patient>>> {
        if (requestParameters.physicianId === null || requestParameters.physicianId === undefined) {
            throw new runtime.RequiredError('physicianId','Required parameter requestParameters.physicianId was null or undefined when calling getPhysicianPatients.');
        }

        const queryParameters: any = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/patients/physician/{physicianId}`.replace(`{${"physicianId"}}`, encodeURIComponent(String(requestParameters.physicianId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatientFromJSON));
    }

    /**
        Request Config Getter
     */
    getPhysicianPatientsRequestOptionsRaw(requestParameters: GetPhysicianPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.physicianId === null || requestParameters.physicianId === undefined) {
            throw new runtime.RequiredError('physicianId','Required parameter requestParameters.physicianId was null or undefined when calling getPhysicianPatients.');
        }

        const queryParameters: any = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/patients/physician/{physicianId}`.replace(`{${"physicianId"}}`, encodeURIComponent(String(requestParameters.physicianId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Returns the Physician\'s patients (Roles: physician, admin)
     */
    async getPhysicianPatients(requestParameters: GetPhysicianPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Patient>> {
        const response = await this.getPhysicianPatientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns patients seen by the physician for concerns matching a skill (e.g. menopause / mensHealth) (Roles: physician, admin)
     */
    async getPhysicianPatientsBySkillRaw(requestParameters: GetPhysicianPatientsBySkillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Patient>>> {
        if (requestParameters.physicianId === null || requestParameters.physicianId === undefined) {
            throw new runtime.RequiredError('physicianId','Required parameter requestParameters.physicianId was null or undefined when calling getPhysicianPatientsBySkill.');
        }

        if (requestParameters.skill === null || requestParameters.skill === undefined) {
            throw new runtime.RequiredError('skill','Required parameter requestParameters.skill was null or undefined when calling getPhysicianPatientsBySkill.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/patients/physician/{physicianId}/by-skill/{skill}`.replace(`{${"physicianId"}}`, encodeURIComponent(String(requestParameters.physicianId))).replace(`{${"skill"}}`, encodeURIComponent(String(requestParameters.skill))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatientFromJSON));
    }

    /**
        Request Config Getter
     */
    getPhysicianPatientsBySkillRequestOptionsRaw(requestParameters: GetPhysicianPatientsBySkillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.physicianId === null || requestParameters.physicianId === undefined) {
            throw new runtime.RequiredError('physicianId','Required parameter requestParameters.physicianId was null or undefined when calling getPhysicianPatientsBySkill.');
        }

        if (requestParameters.skill === null || requestParameters.skill === undefined) {
            throw new runtime.RequiredError('skill','Required parameter requestParameters.skill was null or undefined when calling getPhysicianPatientsBySkill.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/patients/physician/{physicianId}/by-skill/{skill}`.replace(`{${"physicianId"}}`, encodeURIComponent(String(requestParameters.physicianId))).replace(`{${"skill"}}`, encodeURIComponent(String(requestParameters.skill))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Returns patients seen by the physician for concerns matching a skill (e.g. menopause / mensHealth) (Roles: physician, admin)
     */
    async getPhysicianPatientsBySkill(requestParameters: GetPhysicianPatientsBySkillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Patient>> {
        const response = await this.getPhysicianPatientsBySkillRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Marks a patient as deceased (Roles: physician)
     */
    async markDeceasedRaw(requestParameters: MarkDeceasedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Patient>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling markDeceased.');
        }

        if (requestParameters.date === null || requestParameters.date === undefined) {
            throw new runtime.RequiredError('date','Required parameter requestParameters.date was null or undefined when calling markDeceased.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/patient/{patientId}/mark-deceased/{date}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"date"}}`, encodeURIComponent(String(requestParameters.date))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    markDeceasedRequestOptionsRaw(requestParameters: MarkDeceasedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling markDeceased.');
        }

        if (requestParameters.date === null || requestParameters.date === undefined) {
            throw new runtime.RequiredError('date','Required parameter requestParameters.date was null or undefined when calling markDeceased.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/patient/{patientId}/mark-deceased/{date}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"date"}}`, encodeURIComponent(String(requestParameters.date))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Marks a patient as deceased (Roles: physician)
     */
    async markDeceased(requestParameters: MarkDeceasedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Patient> {
        const response = await this.markDeceasedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a patient\'s HealthCard (Roles: patient, admin, physician)
     */
    async removeHealthCardRaw(requestParameters: RemoveHealthCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Patient>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling removeHealthCard.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-card/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    removeHealthCardRequestOptionsRaw(requestParameters: RemoveHealthCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling removeHealthCard.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-card/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Removes a patient\'s HealthCard (Roles: patient, admin, physician)
     */
    async removeHealthCard(requestParameters: RemoveHealthCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Patient> {
        const response = await this.removeHealthCardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a patient\'s OHIP number (Roles: patient, admin, physician)
     */
    async removeOhipNumberRaw(requestParameters: RemoveOhipNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Patient>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling removeOhipNumber.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ohip/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    removeOhipNumberRequestOptionsRaw(requestParameters: RemoveOhipNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling removeOhipNumber.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ohip/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Removes a patient\'s OHIP number (Roles: patient, admin, physician)
     */
    async removeOhipNumber(requestParameters: RemoveOhipNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Patient> {
        const response = await this.removeOhipNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sends an SMS to the patient (Roles: physician, admin)
     */
    async sendSMSRaw(requestParameters: SendSMSRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling sendSMS.');
        }

        if (requestParameters.stringResource === null || requestParameters.stringResource === undefined) {
            throw new runtime.RequiredError('StringResource','Required parameter requestParameters.stringResource was null or undefined when calling sendSMS.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/patients/{id}/sms`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StringResourceToJSON(requestParameters.stringResource),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    sendSMSRequestOptionsRaw(requestParameters: SendSMSRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling sendSMS.');
        }

        if (requestParameters.stringResource === null || requestParameters.stringResource === undefined) {
            throw new runtime.RequiredError('StringResource','Required parameter requestParameters.stringResource was null or undefined when calling sendSMS.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/patients/{id}/sms`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: StringResourceToJSON(requestParameters.stringResource),
        };
        return responseConfig
    }

    /**
     * Sends an SMS to the patient (Roles: physician, admin)
     */
    async sendSMS(requestParameters: SendSMSRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendSMSRaw(requestParameters, initOverrides);
    }

    /**
     * Submit to cancellation list (Roles: patient)
     */
    async submitToCancellationListRaw(requestParameters: SubmitToCancellationListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling submitToCancellationList.');
        }

        if (requestParameters.patientListItem === null || requestParameters.patientListItem === undefined) {
            throw new runtime.RequiredError('PatientListItem','Required parameter requestParameters.patientListItem was null or undefined when calling submitToCancellationList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/patients/{id}/cancellation-list`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PatientListItemToJSON(requestParameters.patientListItem),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    submitToCancellationListRequestOptionsRaw(requestParameters: SubmitToCancellationListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling submitToCancellationList.');
        }

        if (requestParameters.patientListItem === null || requestParameters.patientListItem === undefined) {
            throw new runtime.RequiredError('PatientListItem','Required parameter requestParameters.patientListItem was null or undefined when calling submitToCancellationList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/patients/{id}/cancellation-list`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: PatientListItemToJSON(requestParameters.patientListItem),
        };
        return responseConfig
    }

    /**
     * Submit to cancellation list (Roles: patient)
     */
    async submitToCancellationList(requestParameters: SubmitToCancellationListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.submitToCancellationListRaw(requestParameters, initOverrides);
    }

    /**
     * Transfers a patient\'s account information to another (Roles: admin)
     */
    async transferAccountRaw(requestParameters: TransferAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Patient>> {
        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling transferAccount.');
        }

        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to','Required parameter requestParameters.to was null or undefined when calling transferAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/patient/transfer-account/{from}/{to}`.replace(`{${"from"}}`, encodeURIComponent(String(requestParameters.from))).replace(`{${"to"}}`, encodeURIComponent(String(requestParameters.to))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    transferAccountRequestOptionsRaw(requestParameters: TransferAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling transferAccount.');
        }

        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to','Required parameter requestParameters.to was null or undefined when calling transferAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/patient/transfer-account/{from}/{to}`.replace(`{${"from"}}`, encodeURIComponent(String(requestParameters.from))).replace(`{${"to"}}`, encodeURIComponent(String(requestParameters.to))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Transfers a patient\'s account information to another (Roles: admin)
     */
    async transferAccount(requestParameters: TransferAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Patient> {
        const response = await this.transferAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unlinks accounts (patient, admin)
     */
    async unlinkAccountsRaw(requestParameters: UnlinkAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Patient>> {
        if (requestParameters.parentId === null || requestParameters.parentId === undefined) {
            throw new runtime.RequiredError('parentId','Required parameter requestParameters.parentId was null or undefined when calling unlinkAccounts.');
        }

        if (requestParameters.linkedId === null || requestParameters.linkedId === undefined) {
            throw new runtime.RequiredError('linkedId','Required parameter requestParameters.linkedId was null or undefined when calling unlinkAccounts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/patients/{parentId}/linked-accounts/{linkedId}`.replace(`{${"parentId"}}`, encodeURIComponent(String(requestParameters.parentId))).replace(`{${"linkedId"}}`, encodeURIComponent(String(requestParameters.linkedId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    unlinkAccountsRequestOptionsRaw(requestParameters: UnlinkAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.parentId === null || requestParameters.parentId === undefined) {
            throw new runtime.RequiredError('parentId','Required parameter requestParameters.parentId was null or undefined when calling unlinkAccounts.');
        }

        if (requestParameters.linkedId === null || requestParameters.linkedId === undefined) {
            throw new runtime.RequiredError('linkedId','Required parameter requestParameters.linkedId was null or undefined when calling unlinkAccounts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/patients/{parentId}/linked-accounts/{linkedId}`.replace(`{${"parentId"}}`, encodeURIComponent(String(requestParameters.parentId))).replace(`{${"linkedId"}}`, encodeURIComponent(String(requestParameters.linkedId))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Unlinks accounts (patient, admin)
     */
    async unlinkAccounts(requestParameters: UnlinkAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Patient> {
        const response = await this.unlinkAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a patient\'s health card number (Roles: patient, admin, physician)
     */
    async updateHealthCardRaw(requestParameters: UpdateHealthCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Patient>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling updateHealthCard.');
        }

        if (requestParameters.healthCard === null || requestParameters.healthCard === undefined) {
            throw new runtime.RequiredError('HealthCard','Required parameter requestParameters.healthCard was null or undefined when calling updateHealthCard.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-card/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HealthCardToJSON(requestParameters.healthCard),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updateHealthCardRequestOptionsRaw(requestParameters: UpdateHealthCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling updateHealthCard.');
        }

        if (requestParameters.healthCard === null || requestParameters.healthCard === undefined) {
            throw new runtime.RequiredError('HealthCard','Required parameter requestParameters.healthCard was null or undefined when calling updateHealthCard.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-card/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: HealthCardToJSON(requestParameters.healthCard),
        };
        return responseConfig
    }

    /**
     * Updates a patient\'s health card number (Roles: patient, admin, physician)
     */
    async updateHealthCard(requestParameters: UpdateHealthCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Patient> {
        const response = await this.updateHealthCardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a patient\'s OHIP number (Roles: patient, admin, physician)
     */
    async updateOhipNumberRaw(requestParameters: UpdateOhipNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Patient>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling updateOhipNumber.');
        }

        if (requestParameters.oHIPNumber === null || requestParameters.oHIPNumber === undefined) {
            throw new runtime.RequiredError('OHIPNumber','Required parameter requestParameters.oHIPNumber was null or undefined when calling updateOhipNumber.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ohip/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OHIPNumberToJSON(requestParameters.oHIPNumber),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updateOhipNumberRequestOptionsRaw(requestParameters: UpdateOhipNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling updateOhipNumber.');
        }

        if (requestParameters.oHIPNumber === null || requestParameters.oHIPNumber === undefined) {
            throw new runtime.RequiredError('OHIPNumber','Required parameter requestParameters.oHIPNumber was null or undefined when calling updateOhipNumber.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ohip/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: OHIPNumberToJSON(requestParameters.oHIPNumber),
        };
        return responseConfig
    }

    /**
     * Updates a patient\'s OHIP number (Roles: patient, admin, physician)
     */
    async updateOhipNumber(requestParameters: UpdateOhipNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Patient> {
        const response = await this.updateOhipNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the Patient with the specified id (Roles: patient, physician, admin)
     */
    async updatePatientRaw(requestParameters: UpdatePatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Patient>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updatePatient.');
        }

        if (requestParameters.patient === null || requestParameters.patient === undefined) {
            throw new runtime.RequiredError('Patient','Required parameter requestParameters.patient was null or undefined when calling updatePatient.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/patients/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PatientToJSON(requestParameters.patient),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updatePatientRequestOptionsRaw(requestParameters: UpdatePatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updatePatient.');
        }

        if (requestParameters.patient === null || requestParameters.patient === undefined) {
            throw new runtime.RequiredError('Patient','Required parameter requestParameters.patient was null or undefined when calling updatePatient.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/patients/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: PatientToJSON(requestParameters.patient),
        };
        return responseConfig
    }

    /**
     * Updates the Patient with the specified id (Roles: patient, physician, admin)
     */
    async updatePatient(requestParameters: UpdatePatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Patient> {
        const response = await this.updatePatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate a read-only patient portal preview session for staff troubleshooting (Roles: physician, admin)
     */
    async viewAsPatientRaw(requestParameters: ViewAsPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ViewAsPatientPayload>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling viewAsPatient.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/patient/{patientId}/view-as`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViewAsPatientPayloadFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    viewAsPatientRequestOptionsRaw(requestParameters: ViewAsPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling viewAsPatient.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/patient/{patientId}/view-as`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Generate a read-only patient portal preview session for staff troubleshooting (Roles: physician, admin)
     */
    async viewAsPatient(requestParameters: ViewAsPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ViewAsPatientPayload> {
        const response = await this.viewAsPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
